import { Box } from '@mui/material';
import styles from '../styles.module.css';

function CustomNoRowsOverlay() {
    return (
        <Box className={styles['custom-result']}>
            <h2>Sin registros</h2>
        </Box>
    );
}

export default CustomNoRowsOverlay;
